// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"127":"d31a3f21078f37354ab5","560":"5bb5f7c7bcb7bb4aec08","925":"76758dd736058a078e3e"}[chunkId] + ".js";
};